dependOnExistence